"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.disableUndoButton = disableUndoButton;
exports.saveCreatedSlotForUndo = saveCreatedSlotForUndo;
exports.saveDeletedSlotForUndo = saveDeletedSlotForUndo;
exports.saveUpdatedSlotForUndo = saveUpdatedSlotForUndo;
exports.initUndoButton = initUndoButton;
const errors_1 = __importDefault(require("../js/errors"));
const summary_lib_1 = require("../js/summary_lib");
const slot_undo_1 = require("../js/slot_undo");
const summary_dws_1 = require("../js/summary_dws");
const UNDO_BUTTON_ID = "#dws-undo-btn";
let isApplyingUndo = false;
let isCellEditModeOn = false;
function getUndoButton() {
    return document.querySelector(UNDO_BUTTON_ID);
}
function enableUndoButton() {
    if ((0, slot_undo_1.getLastUndoStack)() && !isCellEditModeOn) {
        getUndoButton()?.classList.remove("disabled-btn");
    }
}
function disableUndoButton() {
    getUndoButton()?.classList.add("disabled-btn");
}
function handleCellEditModeChanged(event) {
    isCellEditModeOn = Boolean(event.detail?.isOn);
    if (isCellEditModeOn) {
        disableUndoButton();
        return;
    }
    enableUndoButton();
}
function saveCreatedSlotForUndo(rawSlot, isUsingRequestSlots) {
    if (isUsingRequestSlots || isApplyingUndo || isCellEditModeOn) {
        return;
    }
    (0, slot_undo_1.addToUndoStack)(rawSlot);
    enableUndoButton();
}
function saveDeletedSlotForUndo(rawSlot, isUsingRequestSlots) {
    if (!rawSlot || isUsingRequestSlots || isApplyingUndo || isCellEditModeOn) {
        return;
    }
    (0, slot_undo_1.addToUndoStack)(rawSlot, null, true);
    enableUndoButton();
}
function saveUpdatedSlotForUndo(oldSlot, newSlot, isUsingRequestSlots) {
    if (!oldSlot || !newSlot || isUsingRequestSlots || isApplyingUndo || isCellEditModeOn) {
        return;
    }
    (0, slot_undo_1.addToUndoStack)(newSlot, oldSlot);
    enableUndoButton();
}
function handleUndoDeleteResponses(responses) {
    let hasError = false;
    responses.forEach(response => {
        if (!response?.success) {
            hasError = true;
            return;
        }
        response?.deleteList?.forEach((slotID) => {
            (0, summary_dws_1.deleteSlotFromMap)(slotID);
        });
    });
    if (hasError) {
        (0, summary_lib_1.openAlertModal)(errors_1.default.SLOT.DELETE);
    }
}
function handleUndoCreateResponses(responses) {
    let hasError = false;
    responses.forEach(response => {
        if (!response?.success) {
            hasError = true;
            return;
        }
        if (response.addList && response.addList.length > 0) {
            response.addList.forEach(summary_dws_1.addSlotToMapAndTable);
            return;
        }
        if (response.slot) {
            (0, summary_dws_1.addSlotToMapAndTable)(response.slot);
        }
    });
    if (hasError) {
        (0, summary_lib_1.openAlertModal)(errors_1.default.SLOT.CREATE);
    }
}
function handleUndoUpdateResponses(responses) {
    let hasError = false;
    responses.forEach(response => {
        if (!response?.success) {
            hasError = true;
            return;
        }
        if (response.addList && response.addList.length > 0) {
            response.addList.forEach(summary_dws_1.addSlotToMapAndTable);
            return;
        }
        if (response.slot) {
            (0, summary_dws_1.addSlotToMapAndTable)(response.slot);
        }
    });
    if (hasError) {
        (0, summary_lib_1.openAlertModal)(errors_1.default.SLOT.UPDATE);
    }
}
async function undoLastSlotAction({ activeUserId, activeBranchId }) {
    const lastAction = (0, slot_undo_1.getLastUndoStack)();
    if (!lastAction) {
        return;
    }
    const { undoActionType, slots, newSlots } = lastAction;
    if (undoActionType !== slot_undo_1.ACTIONS_TYPE.DELETE &&
        undoActionType !== slot_undo_1.ACTIONS_TYPE.CREATE &&
        undoActionType !== slot_undo_1.ACTIONS_TYPE.UPDATE) {
        return;
    }
    getUndoButton()?.classList.add("loading");
    (0, slot_undo_1.enableUndoLoading)();
    isApplyingUndo = true;
    try {
        const responses = await (0, slot_undo_1.undoActionRequest)(undoActionType, slots, newSlots, activeUserId, activeBranchId);
        if (undoActionType === slot_undo_1.ACTIONS_TYPE.DELETE) {
            handleUndoDeleteResponses(responses);
        }
        else if (undoActionType === slot_undo_1.ACTIONS_TYPE.CREATE) {
            handleUndoCreateResponses(responses);
        }
        else {
            handleUndoUpdateResponses(responses);
        }
        (0, slot_undo_1.removeLastActionFromUndoStack)();
        (0, slot_undo_1.removeDeletedSlotInStack)(undoActionType, slots);
        disableUndoButton();
    }
    catch (err) {
        (0, summary_lib_1.openAlertModal)("エラーが発生しました。恐れ入りますが、ページをリロードして再度お試しください。");
    }
    finally {
        isApplyingUndo = false;
        (0, slot_undo_1.disableUndoLoading)();
        getUndoButton()?.classList.remove("loading");
        enableUndoButton();
    }
}
function initUndoButton(options) {
    enableUndoButton();
    window.addEventListener("cellEditModeChanged", handleCellEditModeChanged);
    getUndoButton()?.addEventListener("click", () => {
        if (getUndoButton()?.classList.contains("disabled-btn")) {
            return;
        }
        undoLastSlotAction(options);
    });
}
